export default __webpack_public_path__ + "form-section-blob-2.svg";